{
  "types": {
    "Instruction": [
      { "name": "salt", "type": "uint256" },
      { "name": "maxExecutions", "type": "uint256" },
      { "name": "action", "type": "address" },
      {
        "name": "sweepSkipCCTPDepositAccount",
        "type": "SweepSkipCCTPDepositAccount"
      }
    ],
    "SweepSkipCCTPDepositAccount": [
      { "name": "depositor", "type": "address" },
      { "name": "destinationDomain", "type": "uint32" },
      { "name": "destinationMintRecipient", "type": "bytes32" },
      { "name": "threshold", "type": "uint256" },
      { "name": "fee", "type": "Fee" }
    ],
    "Fee": [
      { "name": "token", "type": "address" },
      { "name": "maxBaseFeePerGas", "type": "uint256" },
      { "name": "maxPriorityFeePerGas", "type": "uint256" },
      { "name": "executionFee", "type": "uint256" }
    ]
  }
}
